<div class="list-groups-container">
  <div
    data-cy="list-groups-section"
    cdkDropList
    [cdkDropListAutoScrollStep]="10"
  >
    <button
      *ngFor="let group of groups; let i = index"
      id="{{
        group?.groupName !== 'Unassigned Group'
          ? 'list-groups-button-' + i
          : 'list-groups-unassigned-button'
      }}"
      [attr.data-cy]="'list-groups-button-' + i"
      class="list-groups-button"
      [class.selected]="group.groupName === selectedGroup"
      [item]="group"
      (click)="changeSelectedGroup(group, 'list-groups-button-' + i)"
      (cdkDragDropped)="onDragDropped($event)"
      cdkDrag
      lmaDragDropItem
    >
      <div
        [attr.data-cy]="'list-groups-button-section-' + i"
        class="button-content"
      >
        <span [attr.data-cy]="'list-groups-button-group-name-text-' + i">
          {{ group?.groupName }}&nbsp;
        </span>
        <p [attr.data-cy]="'list-groups-button-num-products-text-' + i">
          ({{ group?.itemCount || 0 }})
        </p>
        <ion-icon
          [attr.data-cy]="'list-groups-button-drag-drop-icon-' + i"
          cdkDragHandle
          name="menu-outline"
        ></ion-icon>
      </div>
    </button>
  </div>

  <ion-card
    *ngIf="newGroupCard"
    data-cy="list-groups-new-group-section"
    class="list-new-group-card"
    mode="ios"
  >
    <span data-cy="list-groups-new-group-input-section" class="new-group-input">
      <ion-input
        data-cy="list-groups-new-group-input"
        [class.group-name-exists]="newGroupCard.groupNameExists"
        inputmode="text"
        maxlength="30"
        placeholder="{{ 'i18n.lists.enterGroupName' | translate }}"
        required="true"
        [(ngModel)]="newGroupCard.groupName"
        (ngModelChange)="getGroupNameExists()"
      >
      </ion-input>
      <ion-icon
        id="create-group-btn"
        data-cy="list-groups-create-group-button"
        [class.disabled]="newGroupCard.groupNameExists || !trimmedGroupName"
        name="checkmark-circle-outline"
        (click)="onCreateGroup()"
      ></ion-icon>
      <ion-icon
        id="remove-group-btn"
        data-cy="list-groups-remove-group-button"
        name="close-circle-outline"
        (click)="removeNewGroupCard()"
      ></ion-icon>
    </span>
    <span
      *ngIf="newGroupCard.groupNameExists"
      data-cy="list-groups-group-name-exists-text"
      class="group-name-exists-error"
    >
      {{ 'i18n.lists.groupNameExists' | translate }}
    </span>
  </ion-card>
</div>

<div
  *ngIf="groups?.length === 0"
  data-cy="list-groups-unassigned-group-section"
  class="list-groups-container"
>
  <ion-button
    data-cy="list-groups-unassigned-group-button"
    class="list-groups-button"
    mode="ios"
    [disabled]="true"
  >
    <div
      data-cy="list-groups-unassigned-group-button-section"
      class="button-content"
    >
      <span data-cy="list-groups-unassigned-group-text">
        {{ 'i18n.lists.unassignedGroup' | translate }}&nbsp;
      </span>
      <p data-cy="list-groups-unassigned-group-num-products-text">(0)</p>
      <ion-icon
        data-cy="list-groups-unassigned-group-icon"
        name="menu-outline"
      ></ion-icon>
    </div>
  </ion-button>
</div>
